import { useEffect, useRef, useState } from "react";

// Intersection-observer reveal hook.
// Destructured primitive args so the dependency array can include them
// without triggering re-observer on every render.
export const useReveal = ({
  threshold = 0.15,
  rootMargin = "0px 0px -60px 0px",
} = {}) => {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            setInView(true);
            obs.unobserve(e.target);
          }
        });
      },
      { threshold, rootMargin }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [threshold, rootMargin]);

  return { ref, inView };
};
